import React, { useState } from "react";
import { Box, Tab, Tabs } from "@mui/material";
import FormLibrary from './FormLibrary/FormLibrary';
import FormBuilder from './FormBuilder/FormBuilder';
import ReportBuilder from './ReportBuilder/ReportBuilder';
import FormReport from './FormReport/FormReport';
import { AnalyticsBrowser } from '@segment/analytics-next'
import { SEGMENTAPIKEY } from '../../config';

const analytics = AnalyticsBrowser.load({ writeKey: SEGMENTAPIKEY })

export default function Forms(props) {
    const [activeKey, setActiveKey] = useState('formLibrary');

    const handleKeyChange = (event, activeKey) => {
        setActiveKey(activeKey);
    };

    return (
        <Box>
            <Tabs
                value={activeKey}
                onChange={handleKeyChange}
                variant="scrollable"
                sx={{
                    borderBottom: 1,
                    borderColor: 'divider',
                    '& .Mui-selected': {
                        backgroundColor: '#f0f0f0',
                        fontWeight: 'bold',
                    },
                }}
            >
                {props.user.permissions.FormLibraryTab && <Tab key={"formLibrary"} value={"formLibrary"} label="Form Library" />}
                {props.user.permissions.FormBuilderTab && <Tab key={"formBuilder"} value={"formBuilder"} label="Form Builder" />}
                {props.user.permissions.ReportBuilderTab && <Tab key={"reportBuilder"} value={"reportBuilder"} label="Report Builder" />}
                {props.user.permissions.FormReportsTab && <Tab key={"formReports"} value={"formReports"} label="Form Reports" />}
            </Tabs>

            <Box sx={{ p: 1 }}>
                {activeKey === "formLibrary" && <FormLibrary user={props.user} comp_id={props.comp_id} />}
                {activeKey === "formBuilder" && <FormBuilder user={props.user} comp_id={props.comp_id} />}
                {activeKey === "reportBuilder" && <ReportBuilder user={props.user} comp_id={props.comp_id} />}
                {activeKey === "formReports" && <FormReport user={props.user} comp_id={props.comp_id} />}
            </Box>
        </Box>
    );
};